module.exports = __webpack_public_path__ + "static/media/000005.506053fe.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/000005.mp3
// module id = 828
// module chunks = 0